import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { FileText, ExternalLink, AlertCircle, CheckCircle2 } from "lucide-react";

export default function EditorIndex() {
  const [pages, setPages] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api
      .get("/cms/pages")
      .then((res) => setPages(res.data))
      .catch((e) => setError(e?.response?.data?.detail || "Failed to load pages"));
  }, []);

  if (error) return <div className="card-clay p-8 text-red-700 bg-red-50 border-red-200" data-testid="editor-error">{error}</div>;
  if (!pages) return <div className="card-clay p-10 text-center text-slate-400">Loading pages…</div>;

  return (
    <div data-testid="editor-pages-grid">
      <div className="mb-4">
        <h2 className="font-fredoka text-2xl font-bold text-slate-900">Public website pages</h2>
        <p className="text-sm text-slate-500 mt-1">Pick a page to edit its words, images, and links. Operations data (orders, payments, schedules) is managed separately in <Link to="/admin" className="text-green-700 font-semibold hover:underline">Operations Admin</Link>.</p>
      </div>

      <div className="grid sm:grid-cols-2 gap-3">
        {pages.map((p) => (
          <Link
            key={p.slug}
            to={`/editor/page/${p.slug}`}
            className="card-clay p-5 flex items-start gap-3 hover:border-green-400 transition"
            data-testid={`editor-page-${p.slug}`}
          >
            <div className="w-10 h-10 rounded-xl bg-green-100 text-green-700 flex items-center justify-center flex-shrink-0">
              <FileText strokeWidth={2.5} size={18}/>
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-fredoka font-bold text-slate-900 flex items-center gap-2">
                {p.label}
                <ExternalLink size={12} className="text-slate-300"/>
              </div>
              <div className="text-xs text-slate-500 mt-0.5">{p.block_count} editable blocks</div>
              <div className="mt-2">
                {p.unpublished_changes > 0 ? (
                  <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full bg-amber-100 text-amber-800 border border-amber-200" data-testid={`editor-page-${p.slug}-draft`}>
                    <AlertCircle size={10}/> {p.unpublished_changes} unpublished
                  </span>
                ) : (
                  <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full bg-green-100 text-green-800 border border-green-200">
                    <CheckCircle2 size={10}/> Published
                  </span>
                )}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
